export const tagMixins = {
  data() {
    return {
      formData: {
        id: null,
        name: "",
        tagCategoryId: null,
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入标签名称",
            trigger: ["blur", "change"],
          },
          {
            pattern: /^[\s\S]{0,8}$/,
            message: "不得超过8个文字",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  methods: {
    clearForm() {
      this.formData.id = null;
      this.formData.name = "";
      this.formData.tagCategoryId = this.tagCategoryList.data[0].id;
    },
    handleConfirm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          await this.saveTagValue({
            ...this.formData,
          });
          if (this.formData.id) {
            this.$message.success("编辑成功");
          } else {
            this.$message.success("添加成功");
          }
          this.setData({ key: "isBack", value: true });
          this.$router.go(-1);
        }
      });
    },
    handleAdd() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          await this.saveTagValue({
            ...this.formData,
          });
          this.$message.success("添加成功");
          this.formData.id = null;
          this.formData.name = "";
          this.$nextTick(() => {
            this.$refs.form.clearValidate();
          });
        }
      });
    },
  },
};
